import { render, staticRenderFns } from "./form_change_pass_security_components.vue?vue&type=template&id=45b8da93&scoped=true"
import script from "./form_change_pass_security_components.vue?vue&type=script&lang=js"
export * from "./form_change_pass_security_components.vue?vue&type=script&lang=js"
import style0 from "./form_change_pass_security_components.vue?vue&type=style&index=0&id=45b8da93&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8da93",
  null
  
)

export default component.exports